import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { useGoLiveNow } from '../../hooks/broadcast';
import { useDeleteScheduledBroadcast, } from '../../state/scheduleState';
import { useShare } from '../../utils';
import { East, Popup } from '../../utils/popups';
import { getStreamUrl } from '../../utils/url';
import { BroadcastNameplate } from '../BroadcastNameplate';
import { EditIcon, ShareIcon, TrashCanIcon } from '../Icon';
import { PopupButton } from '../PopupButton';
import { ScrollableContainer } from '../ScrollableContainer';
import { StackContent } from '../Stack';
import { TextButton } from '../TextButton';
import { BroadcastName } from '../Ui';
import { AbstractPopup } from './AbstractPopup';
import { confirm } from './ConfirmationPopup';
import { scheduleBroadcast } from './ScheduleBroadcastPopup';
export function BroadcastItemInfoPopup({ resolve, broadcast, ...props }) {
    const broadcastId = broadcast?.id;
    const streamPartId = broadcast?.streamPartId;
    const { canShare, openSystemShareDialog } = useShare();
    const deleteBroadcast = useDeleteScheduledBroadcast();
    const startBroadcast = useGoLiveNow();
    return (_jsx(BroadcastItemInfoPopupRoot, { translateFn: East, ...props, children: _jsx(Wrap, { children: _jsx(Content, { children: _jsxs(StackContent, { children: [_jsxs(Header, { children: [_jsx(TextButton, { type: "button", onClick: () => {
                                        resolve();
                                    }, children: "Done" }), _jsx(BroadcastName, { children: broadcast?.name || '' })] }), !!streamPartId && (_jsx(BroadcastNameplate, { streamPartId: streamPartId, onGoLiveClick: () => {
                                resolve();
                                setTimeout(() => {
                                    startBroadcast({
                                        streamPartId,
                                        saveBroadcast: false,
                                    });
                                }, 250);
                            } })), _jsx(PopupButton, { type: "button", onClick: () => {
                                if (broadcast) {
                                    scheduleBroadcast(broadcast);
                                }
                                resolve();
                            }, prependComponent: _jsx(EditIcon, {}), children: "Edit link" }), canShare && !!streamPartId && (_jsx(PopupButton, { type: "button", onClick: () => {
                                openSystemShareDialog(getStreamUrl(streamPartId));
                            }, prependComponent: _jsx(ShareIcon, {}), children: "Share link" })), _jsx(PopupButton, { type: "button", onClick: async () => {
                                resolve();
                                if (broadcastId) {
                                    if (await confirm({
                                        title: 'Delete link',
                                        okLabel: 'Delete link',
                                        cancelLabel: 'Cancel',
                                        message: (_jsx(_Fragment, { children: "This link will no longer work for anyone who's\u00A0received it." })),
                                    })) {
                                        deleteBroadcast(broadcastId);
                                    }
                                }
                            }, prependComponent: _jsx(TrashCanIcon, {}), children: "Delete link" })] }) }) }) }));
}
const Content = styled(ScrollableContainer) `
    height: calc(var(--vh-100, 100vh) - 3rem);

    @media (min-width: 32.5rem) {
        height: auto;
        max-height: calc(var(--vh-100, 100vh) - 2rem - 3rem);
    }
`;
const Wrap = styled.div `
    padding: 1.5rem 0;

    ${StackContent} {
        padding: 0 1.5rem;
    }
`;
const Header = styled.div `
    ${BroadcastName} {
        margin-top: 1.5rem;
    }
`;
const BroadcastItemInfoPopupRoot = styled(AbstractPopup) `
    --Popup_InitialOffsetX: 0;
    --Popup_InitialOffsetY: 0;
    --Popup_X: 0;
    --Popup_Y: 0;

    --Popup_Height: var(--vh-100, 100vh);
    --Popup_Width: var(--vw-100, 100vw);
    --Popup_Border: 0;
    --Popup_BoxShadow: none;
    --Popup_Padding: 0;

    /* Offset transitions */
    --Popup_OffsetTransition: none;

    @media (min-width: 32.5rem) {
        --Popup_InitialScale: 0.98;
        --Popup_X: 0;
        --Popup_Y: 0;
        --Popup_Left: 50%;
        --Popup_Top: 50%;
        --Popup_InitialOffsetX: -50%;
        --Popup_InitialOffsetY: calc(-50% + 1rem);
        --Popup_OffsetY: -50%;
        --Popup_BorderRadius: 2rem;

        --Popup_Width: 20.75rem;
        --Popup_MaxWidth: calc(var(--vw-100, 100vw) - 2rem);
        --Popup_Height: auto;
        --Popup_Border: initial;
        --Popup_BoxShadow: initial;

        /* Offset transitions */
        --Popup_OffsetTransition: initial;

        ${Header} {
            display: none;
        }
    }

    @media (min-width: 50rem) {
        --Popup_Left: 0;
        --Popup_Top: 0;
        --Popup_InitialOffsetX: 0;
        --Popup_OffsetX: 1rem;
        --Popup_InitialOffsetY: -50%;
        --Popup_X: min(
            var(--Popup_AnchorX, 0rem),
            calc(100vw - 100% - var(--Popup_OffsetX) - 1rem)
        );
        --Popup_Y: max(
            calc(50% + 1rem),
            min(var(--Popup_AnchorY, 0rem), calc(var(--vh-100, 100vh) - 50% - 1rem))
        );
    }
`;
const broadcastItemInfoPopup = Popup.create(BroadcastItemInfoPopup);
export function showBroadcastInfo(broadcast, options = {}) {
    (async () => {
        try {
            options.onOpenPopup?.();
            await broadcastItemInfoPopup.pop({
                broadcast,
                anchorRef: options.anchorRef,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    })();
}
